import { TextField, Box, Typography, CircularProgress, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useIFSCValidation } from "../Razorpay/useIFSCValidation";
import Swal from "sweetalert2";

const IFSCField = (props) => {
    const {
        control,
        name,
        rules = {},
        defaultValue,
        InputProps,
        errorText,
        disabled = false,
        validateOnChange = true,
        apiProvider = 'razorpay', // 'razorpay', 'bulkpe', 'apyhub'
        apiKey = null,
        onIfscValidation = () => {},
        ...otherProps
    } = props;

    const { validateIFSC, loading, bankDetails, error, clearValidation } = 
        useIFSCValidation(apiProvider);
    
    const [validationTimeout, setValidationTimeout] = useState(null);

    // Clear timeout on unmount
    useEffect(() => {
        return () => {
            if (validationTimeout) {
                clearTimeout(validationTimeout);
            }
        };
    }, [validationTimeout]);

    // Notify parent about bank details changes
    useEffect(() => {
    
        // onIfscValidation(bankDetails?.bank);
    if (bankDetails) {
        onIfscValidation(bankDetails?.bank);
    // //     Swal.fire({
    // //         title: 'Bank Details Found',
    // //         html: `
    // //             <strong>Bank:</strong> ${bankDetails.bank}<br/>
    // //             <strong>Branch:</strong> ${bankDetails.branch}<br/>
    // //             <strong>City:</strong> ${bankDetails.city}, ${bankDetails.state}<br/>
    // //             ${bankDetails.address ? `<strong>Address:</strong> ${bankDetails.address}<br/>` : ''}
    // //             <div style="margin-top: 8px;">
    // //                 ${bankDetails.rtgs ? '<span style="padding: 3px 6px; border: 1px solid green; border-radius: 3px; margin-right: 5px;">RTGS</span>' : ''}
    // //                 ${bankDetails.neft ? '<span style="padding: 3px 6px; border: 1px solid green; border-radius: 3px; margin-right: 5px;">NEFT</span>' : ''}
    // //                 ${bankDetails.imps ? '<span style="padding: 3px 6px; border: 1px solid green; border-radius: 3px; margin-right: 5px;">IMPS</span>' : ''}
    // //                 ${bankDetails.upi  ? '<span style="padding: 3px 6px; border: 1px solid green; border-radius: 3px;">UPI</span>' : ''}
    // //             </div>
    // //         `,
    // //         icon: 'success',
    // //         confirmButtonText: 'OK'
    // //     });
    // }else{
    //     onIfscValidation(null);
    //     console.log("bankDetails",bankDetails)
    }
}, [bankDetails, onIfscValidation]);

    const handleValidation = async (ifscCode) => {
        if (!ifscCode || ifscCode.length !== 11) {
            clearValidation();
            return;
        }

        // Clear existing timeout
        if (validationTimeout) {
            clearTimeout(validationTimeout);
        }

        // Set new timeout for debounced validation
        const timeoutId = setTimeout(async () => {
            await validateIFSC(ifscCode, apiKey);
        }, 800); // 800ms delay

        setValidationTimeout(timeoutId);
    };

    return (
        <Box>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={{
                    ...rules,
                    pattern: {
                        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: 'Enter valid IFSC code (e.g., SBIN0001234)'
                    }
                }}
                render={({ field, fieldState: { error: formError } }) => (
                    <>
                        <TextField
                            {...field}
                            {...otherProps}
                            disabled={disabled}
                            value={field.value?.toUpperCase() || ''}
                            onChange={(event) => {
                                const value = event.target.value.toUpperCase();
                                field.onChange(value);
                                
                                if (validateOnChange) {
                                    handleValidation(value);
                                }
                            }}
                            error={!!(formError || error)}
                            helperText={
                                formError?.message || 
                                error || 
                                (bankDetails&& field.value ? `✓ ${bankDetails.bank} - ${bankDetails.branch}` : null)
                            }
                            fullWidth
                            size="small"
                            InputProps={{
                                ...InputProps,
                                endAdornment: loading ? (
                                    <CircularProgress size={20} />
                                ) : bankDetails && field.value ? (
                                    <Chip 
                                        label="✓ Valid" 
                                        color="success" 
                                        size="small" 
                                        variant="outlined"
                                    />
                                ) : null,
                                style: { 
                                    fontSize: '0.75rem',
                                    textTransform: 'uppercase',
                                    ...InputProps?.style 
                                }
                            }}
                        />
                        
                        {/* Bank Details Display */}
                        {/* {bankDetails && (
                            <Box sx={{ mt: 1, p: 1, bgcolor: 'success.light', borderRadius: 1 }}>
                                <Typography variant="caption" display="block">
                                    <strong>Bank:</strong> {bankDetails.bank}
                                </Typography>
                                <Typography variant="caption" display="block">
                                    <strong>Branch:</strong> {bankDetails.branch}
                                </Typography>
                                <Typography variant="caption" display="block">
                                    <strong>City:</strong> {bankDetails.city}, {bankDetails.state}
                                </Typography>
                                {bankDetails.address && (
                                    <Typography variant="caption" display="block">
                                        <strong>Address:</strong> {bankDetails.address}
                                    </Typography>
                                )}
                                <Box sx={{ mt: 0.5 }}>
                                    {bankDetails.rtgs && <Chip label="RTGS" size="small" sx={{ mr: 0.5, mb: 0.5 }} />}
                                    {bankDetails.neft && <Chip label="NEFT" size="small" sx={{ mr: 0.5, mb: 0.5 }} />}
                                    {bankDetails.imps && <Chip label="IMPS" size="small" sx={{ mr: 0.5, mb: 0.5 }} />}
                                    {bankDetails.upi && <Chip label="UPI" size="small" sx={{ mr: 0.5, mb: 0.5 }} />}
                                </Box>
                            </Box>
                        )} */}
                        {/* show details using swal */}
                    </>
                )}
            />
        </Box>
    );
};

export default IFSCField;